/*
 * AZP-7076 — fills in the "Popular Models" block on the collection page.
 *
 * The counts come from `popular-models.json`, published next to the AZP-7008 model index
 * by `scripts/popular-models/build.mjs`. One file covers every collection, so it is
 * fetched once and read by handle.
 *
 * A model links to `#az_model=`, the same fragment `part-lookup.js` sends a model number
 * typed into the search box to — the facet on the other end already knows how to narrow a
 * grid to it. A fragment, not a query string, for the reason given there: a crawlable URL
 * per model would mint 185,616 pages that all render the same server-side HTML.
 */
(function () {
  "use strict";

  var LIMIT = 20;
  var FILE = "popular-models.json";

  function render(root, models) {
    var list = root.querySelector("[data-popular-models-list]");
    if (!list || !models || !models.length) return;

    var base = (root.dataset.collectionsUrl || "/collections") + "/all";
    var fragment = document.createDocumentFragment();

    models.slice(0, LIMIT).forEach(function (model) {
      var link = document.createElement("a");
      link.className = "collection-popular-models-item";
      link.href = base + "#az_model=" + encodeURIComponent(model);
      link.textContent = model;
      fragment.appendChild(link);
    });

    list.appendChild(fragment);
    root.hidden = false;
  }

  function load(root) {
    var base = root.dataset.indexBase;
    if (!base) return;

    var version = root.dataset.indexVersion;
    var url = base + FILE + (version ? "?v=" + encodeURIComponent(version) : "");

    fetch(url, { credentials: "omit" })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var models = data && data.c ? data.c[root.dataset.collection] : null;
        render(root, models);
      })
      .catch(function () {
        /* The block is already hidden; a collection with no models looks the same as a
         * failed fetch, and neither is worth an error message on a storefront. */
      });
  }

  /* Deferred to idle rather than to an IntersectionObserver: the shell starts `hidden`,
   * and a `display: none` element never intersects anything, so an observer on it would
   * wait forever. The block is below the grid either way, so nothing here is urgent. */
  function schedule(root) {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(function () { load(root); }, { timeout: 2000 });
    } else {
      window.setTimeout(function () { load(root); }, 0);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-popular-models]").forEach(schedule);
  });
})();
